
import { defineComponent, PropType } from 'vue'
import { close } from 'ionicons/icons'
import { IonHeader, IonButton, IonToolbar, IonTitle, IonIcon } from '@ionic/vue'

export default defineComponent({
  components: {
    IonHeader,
    IonButton,
    IonToolbar,
    IonTitle,
    IonIcon,
  },
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    size: {
      type: String as PropType<'small' | 'large' | undefined>,
      default: undefined,
    },
    collapse: {
      type: String as PropType<'condense' | undefined>,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },
  emits: ['close'],
  setup() {
    return {
      close,
    }
  },
})
